import { render, staticRenderFns } from "./dspFormula.vue?vue&type=template&id=79ac6fce&scoped=true&"
import script from "./dspFormula.vue?vue&type=script&lang=js&"
export * from "./dspFormula.vue?vue&type=script&lang=js&"
import style0 from "./dspFormula.vue?vue&type=style&index=0&id=79ac6fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ac6fce",
  null
  
)

export default component.exports